import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {LanguageItemModel} from "../../core/models/language.item.model";
import {USER} from "../../core/common/constant";
import {OauthService} from "../../core/services/oauth.service";
import {LanguageStorage} from "../../core/storage/language.storage";
import {UserStorage} from "../../core/storage/user.storage";
import {TranslateService} from "@ngx-translate/core";
import {CONFIG} from "../../core/config/application.config";
import {LayoutService} from "../../core/services/layout.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {

  languageList = CONFIG.LANGUAGE_DATA;
  constantsUser = USER;

  constructor(private router: Router,
              private oauthService: OauthService,
              public languageStorage: LanguageStorage,
              private translateService: TranslateService,
              public layoutService: LayoutService,
              public userStorage: UserStorage) {}

  ngOnInit() {
  }

  onSubmit() {
    this.router.navigate(["/pages/search"]);
  }

  logout() {
    this.oauthService.logout();
  }

  onChangeLanguage(language: string) {
    this.languageStorage.changeLanguage(language);
    this.translateService.use(language.toLowerCase()).subscribe(res=>{
      window.location.reload();
    });
  }

  toggleSidebar(): void {
    this.layoutService.toggleSidebar();
  }
}
